import { ContainerLoading, Load } from "./styles";

export const Loading = () => {
  return (
    <ContainerLoading>
      <Load />
    </ContainerLoading>
  );
};
